module.exports = __webpack_public_path__ + "img/standardModel-icon-po.ecc74e70.svg";